/**
 * 팀 서비스 메인 export 파일
 * 
 * 이 파일은 모든 팀 관련 함수와 타입을 re-export합니다.
 * 실제 구현은 team/ 디렉토리의 모듈화된 파일들에 있습니다.
 */

// 타입 export
export type {
  Team,
  TeamMember,
  TeamDetail,
  TeamRole,
  MyTeam,
  TeamProfileWithMembers,
  TeamProject,
  TeamUpdateData,
  TeamSearchParams,
} from './team/team-types'

// 조회 함수 export
export {
  fetchTeamProfileByTeamManager,
  fetchTeamProfile,
  fetchMyTeams,
  searchTeams,
  fetchTeamDetail,
  fetchMyTeamsWithRole,
  fetchTeamProfileWithMembers,
  fetchTeamProjects,
  checkTeamDeletionSafety,
} from './team/team-queries'

// 변경 함수 export
export {
  createDefaultTeam,
  requestLeaveTeam,
  leaveTeam,
  approveLeaveRequest,
  rejectLeaveRequest,
  cancelLeaveRequest,
  deleteTeam,
  restoreTeam,
  updateTeam,
  removeTeamMember,
  requestTeamJoin,
} from './team/team-mutations'
